'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomIcon = function ZoomIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 .746h22.8V23.24H0z'
            }),
            _react2.default.createElement('path', {
                id: 'c',
                d: 'M.017.87h10.518v10.38H.017z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'g',
                {
                    transform: 'translate(1 1.13)'
                },
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'b',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#a'
                    })
                ),
                _react2.default.createElement('path', {
                    d: 'M11.4 4.493a7.632 7.632 0 0 0-5.373 2.194A7.404 7.404 0 0 0 3.8 11.99a7.4 7.4 0 0 0 2.227 5.303c2.873 2.835 7.873 2.835 10.746 0A7.4 7.4 0 0 0 19 11.99c0-2.002-.79-3.887-2.227-5.304A7.632 7.632 0 0 0 11.4 4.493M3.34 19.945A11.093 11.093 0 0 1 0 11.991c0-3.005 1.186-5.83 3.34-7.955 4.446-4.388 11.674-4.388 16.12 0 2.154 2.126 3.34 4.95 3.34 7.955 0 3.006-1.186 5.83-3.34 7.954a11.393 11.393 0 0 1-8.06 3.296c-3.046 0-5.907-1.17-8.06-3.296z',
                    fill: '#555',
                    mask: 'url(#b)'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    transform: 'translate(17.2 17.005)'
                },
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'd',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#c'
                    })
                ),
                _react2.default.createElement('path', {
                    d: 'M8.635 11.25c-.486 0-.972-.184-1.343-.55L.574 4.07a1.856 1.856 0 0 1 0-2.65 1.916 1.916 0 0 1 2.686 0L9.98 8.05a1.856 1.856 0 0 1 0 2.65c-.37.366-.857.55-1.344.55',
                    fill: '#555',
                    mask: 'url(#d)'
                })
            )
        )
    );
};

ZoomIcon.defaultProps = {
    width: '30',
    height: '30',
    viewBox: '0 0 30 30',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var Zoom = function (_React$Component) {
    _inherits(Zoom, _React$Component);

    function Zoom() {
        _classCallCheck(this, Zoom);

        return _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).apply(this, arguments));
    }

    _createClass(Zoom, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(ZoomIcon, null)
            );
        }
    }]);

    return Zoom;
}(_react2.default.Component);

exports.default = Zoom;